import { DeleteRequest, GetListRequest, GetListResponse } from "./api.model";

export type RoleGetListRequest = GetListRequest<RoleGetListRequestFilter>;
export type RoleGetListResponse = GetListResponse<Role>;
export type RoleDeleteRequest = DeleteRequest;

export type UserGetListRequest = GetListRequest<UserGetListRequestFilter>;
export type UserGetListResponse = GetListResponse<User>;
export type UserDeleteRequest = DeleteRequest;

// export type PermissionGetListRequest = GetListRequest<PermissionGetListRequestFilter>;
// export type PermissionGetListResponse = GetListResponse<Permission>;
// export type PermissionDeleteRequest = DeleteRequest;

export interface RoleGetListRequestFilter {
  name?: string | null;
  code?: string | null;

  /** @format int32 */
  channel?: number;
}

export interface Role {
  name: string;
  code?: string | null;

  /** @format int32 */
  channel: number;

  /** @format int64 */
  id?: number;

  /** @format byte */
  system_RowVersion?: string | null;
}

export interface RoleInsertRequest {
  name: string;
  code?: string | null;

  /** @format int32 */
  channel: number;
  roleModulePermissions: RoleModulePermissionInsertRequest[];
}

export interface RoleModulePermissionInsertRequest {
  /** @format int32 */
  module?: number;

  /** @format int32 */
  permission?: number;
}

export interface UserGetListRequestFilter {
  /** @format int32 */
  userType?: number | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  password?: string | null;

  /** @format int64 */
  refDialingCode_Id?: number | null;
  mobilePhone?: string | null;
  profileImage?: string | null;
  isDeveloper?: boolean | null;
  isFirstLogin?: boolean | null;
  msadguid?: string | null;
  blocked?: boolean | null;
  isAD?: boolean | null;
  isTwoFactorAuthEnabled?: boolean | null;
}

export type UserType = 1 | 2 | 3;

export interface User {
  userId: number;
  firstName: string | null;
  lastName: string | null;
  userName: string;
  email: string;
  password: string;
  roleId: number;
  profileImage?: string | null;
  isActive: boolean;
  isDeleted: boolean;
  // userType: UserType;
  // firstName?: string | null;
  // lastName?: string | null;
  // email: string;

  // /** @format int64 */
  // refDialingCode_Id?: number | null;
  // mobilePhone?: string | null;
  // profileImage?: string | null;
  // blocked: boolean;
  // isAD: boolean;
  // isTwoFactorAuthEnabled: boolean;

  // /** @format int64 */
  // id?: number;

  // /** @format byte */
  // system_RowVersion?: string | null;
}

export interface UserInsertRequest {
  userType: number;
  firstName?: string | null;
  lastName?: string | null;
  email: string;

  /** @format int64 */
  refDialingCode_Id?: number | null;
  mobilePhone?: string | null;
  profileImage?: string | null;
  blocked: boolean;
  isAD: boolean;
  isTwoFactorAuthEnabled: boolean;
  userTerminals?: UserTerminalInsertRequest[] | null;
  roleId?: UserRoleInsertRequest[] | null;
  userOrganizations: UserOrganizationInsertRequest[];
}

export interface UserOrganizationInsertRequest {
  /** @format int64 */
  refOrganization_Id?: number | null;
}

export interface UserRoleInsertRequest {
  /** @format int64 */
  refRole_Id?: number | null;
}

export interface UserTerminalInsertRequest {
  /** @format int64 */
  refTerminal_Id?: number | null;
}
